<template>
    <div class="grid">
        <div class="col-12 xl:col-5">
            <HorseHistoryChangesDataTable :changes-list="changesHistory" @showRevision="showChangesHistory"/>
        </div>

        <div v-if="selectedVersion" class="selectedVersion col-12 xl:col-7 p-4">
            <RevisionInfo :username="selectedModification.username"
                          :timestamp="selectedModification.timestamp"/>
            <div class="separator mb-3 mt-3"/>
            <DataTable ref="horseCoveringCertificateChangesTable" :value="selectedVersion" dataKey="id" size="small">
                <Column field="season" :header="$t('message.horseEdit.covering.season')" class="w-1">
                    <template #body="{ data }">
                        {{ data.year }}
                    </template>
                </Column>
                <Column field="agreementNumber" :header="$t('message.horseEdit.covering.number')" class="w-1">
                    <template #body="{ data }">
                        {{ data.agreementNumber }}
                    </template>
                </Column>
                <Column field="coveringTypeLabel" :header="$t('message.horseEdit.covering.type')" class="w-2">
                    <template #body="{ data }">
                        {{ data.coveringTypeLabel }}
                    </template>
                </Column>

                <Column field="location" :header="$t('message.horseEdit.covering.semen')" class="w-2">
                    <template #body="{ data }">
                        {{ data.semenTypeLabel }}
                    </template>
                </Column>

                <Column field="location" :header="$t('message.horseEdit.covering.results')" class="w-2">
                    <template #body="{ data }">
                        {{ data.resultTypeLabel }}
                    </template>
                </Column>

                <Column field="location" :header="$t('message.horseEdit.covering.firstCovering')" class="w-2">
                    <template #body="{ data }">
                        {{ data.firstCoveringDate }}
                    </template>
                </Column>

                <Column field="location" :header="$t('message.horseEdit.covering.lastCovering')" class="w-2">
                    <template #body="{ data }">
                        {{ data.lastCoveringDate }}
                    </template>
                </Column>

                <Column field="externalStallionName" :header="$t('message.horseEdit.covering.externalStallion')" class="w-2">
                    <template #body="{ data }">
                        {{ data.externalStallionName }}
                    </template>
                </Column>

                <template #empty>
                    {{ $t('message.other.emptyTable') }}
                </template>
            </DataTable>
        </div>

    </div>
</template>

<script>
import {
    getCoveringCertificatesAuditTrail,
    getCoveringCertificatesForRevision
} from "@/swagger/vue-api-client";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import HorseHistoryChangesDataTable
    from "@/views/horse/horseEdit/history/compontents/HorseHistoryChangesDataTable.vue";
import RevisionInfo from "@/views/horse/horseEdit/history/compontents/RevisionInfo.vue";

export default {
    name: "HorseCoveringCertificatesHistoryTab",

    components: {
        RevisionInfo,
        HorseHistoryChangesDataTable,
        TabPanel,
        TabView,
        DataTable,
        Column
    },

    props: {
        horse: null,
    },

    data() {
        return {
            changesHistory: null,
            selectedVersion: null,
            selectedModification: {
                timestamp: null,
                username: null
            }
        };
    },

    beforeMount() {
        getCoveringCertificatesAuditTrail({id: this.horse.id}).then((response => {
            this.changesHistory = response.data;
            const lastHistoryEntry = this.changesHistory.length > 0 ? this.changesHistory[0] : undefined;
            const lastRevision = lastHistoryEntry ? lastHistoryEntry.revision : null;
            if (lastRevision != null) {
                this.selectedModification.timestamp = lastHistoryEntry.timestamp;
                this.selectedModification.username = lastHistoryEntry.username;
                getCoveringCertificatesForRevision({id: this.horse.id, revision: lastRevision}).then((response) => {
                    this.selectedVersion = response.data;
                });
            }
        }));

    },

    methods: {
        showChangesHistory(event) {
            if (event?.data?.revision) {
                getCoveringCertificatesForRevision({id: this.horse.id, revision: event.data.revision}).then((response) => {
                    this.selectedVersion = response.data;
                    this.selectedModification.timestamp = event?.data?.timestamp;
                    this.selectedModification.username = event?.data?.username;
                });
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
    .selectedVersion {
        background-color: var(--secondary-color);
        color: var(--dates-text-color);
        border-radius: 7px;
    }
    .separator {
        width: 100%;
        height: 1.5px;
        background-color: var(--separator-color);
    }
</style>
